var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKavachiconnew2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.916748L2.75 4.58341V10.0834C2.75 15.1709 6.27 19.9284 11 21.0834C15.73 19.9284 19.25 15.1709 19.25 10.0834V4.58341L11 0.916748ZM9.16667 15.5834L5.5 11.9167L6.7925 10.6242L9.16667 12.9892L15.2075 6.94841L16.5 8.25008L9.16667 15.5834Z",
    fill: "#0D6B6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKavachiconnew2);
export default __webpack_public_path__ + "static/media/kavachiconnew2.f3bedac7dc144a2c3a92c1e01ac9eedc.svg";
export { ForwardRef as ReactComponent };